<div class="container pt-2 pb-2 about-us">
  <p>Wickedlist is America’s #1 destination for free adult personal classifieds. It provides people
    from all parts of the United States an opportunity to find true love or casual thing-depends on
    what people are looking for. With the location and preference-based searches, it makes it
    easier for you to meet people with similar interests and lifestyles nearby.</p>

  <p>Wickedkist is the fastest growing platform for interacting and coming across new people. We
    focus upon people and their needs for easy to navigate website with the content for every
    sexual orientation. We help people create meaningful connections, which ignite the fire in their
    hearts and inspire people to share about themselves authentically and enthusiastically.</p>

  <p>Our ads let you share who you really are, letting like-minded people find you. Wickedlist is
    more than just a platform, it’s a chance. We encourage the people to be honest while boosting
    integrity, equality, kindness, respect as well as confidence in all aspects of the interaction.</p>
  <p>Wickedlist lets people learn more about themselves and how to form and maintain healthier
    connections.</p>

  <p>It’s never without the acquiescence of fate that two people end up in the exact same spot at
    the same time. Would you want to miss out on such an opportunity?. Healthier relationships are crucially important for a positive and productive life. We, as a social
    platform, empower the people while they form connections, let it be dating, searching for
    friends, or looking for a good time. One ad that you post on the Wickedlist could change your
    life.</p>
  <p>We have zero-tolerance for bad behavior and hate speech. We will fight with prostitution, racist
    and rude comments, and will remove naked pictures or whole ads if they would be against our
    terms of use. Wickedlist is a platform build upon the foundation of mutual respect and
    kindness.</p>
  <p>
    We’re extremely happy and incredibly proud to spark hundreds of thousands of encounters and
    wish to be a continual source of beautiful stories.
  </p>
</div>
